import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=6e17d39a&scoped=true&"
import script from "./NewsSlider.vue?vue&type=script&lang=js&"
export * from "./NewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&id=6e17d39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17d39a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e17d39a')) {
      api.createRecord('6e17d39a', component.options)
    } else {
      api.reload('6e17d39a', component.options)
    }
    module.hot.accept("./NewsSlider.vue?vue&type=template&id=6e17d39a&scoped=true&", function () {
      api.rerender('6e17d39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/NewsSlider.vue"
export default component.exports